import { For, Show } from 'solid-js'
import type { HubCheckIn } from '../../lib/hub'

/** A short, newest-first slice of settled check-ins, with a link to the full list. */
export default function RecentHistoryCard(props: {
  recentHistory: HubCheckIn[]
  onSeeAll: () => void
}) {
  const euros = (cents: number) => `€${(cents / 100).toFixed(2)}`
  const when = (iso: string) => {
    const d = new Date(iso)
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' })
  }

  return (
    <section class="rounded-2xl bg-white/5 border border-white/10 p-5">
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-sm font-semibold text-white/80">Recent activity</h2>
        <button
          type="button"
          onClick={() => props.onSeeAll()}
          class="text-xs text-emerald-300 hover:text-emerald-200 transition-colors"
        >
          See all
        </button>
      </div>

      <Show
        when={props.recentHistory.length > 0}
        fallback={<p class="text-sm text-white/50">Nothing here yet — your check-ins will show up.</p>}
      >
        <ul class="space-y-2">
          <For each={props.recentHistory}>
            {(checkIn) => (
              <li class="flex items-center justify-between rounded-lg bg-black/20 px-3 py-2.5">
                <div class="min-w-0">
                  <p class="text-sm text-white truncate">{checkIn.venueName}</p>
                  <p class="text-[11px] text-white/40">
                    {when(checkIn.createdAt)} · {checkIn.items.length} item
                    {checkIn.items.length === 1 ? '' : 's'}
                  </p>
                </div>
                <span class="text-sm font-medium text-white/70 tabular-nums shrink-0 ml-3">
                  {euros(checkIn.totalAmount)}
                </span>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </section>
  )
}
